import { gql } from '@apollo/client';

export const CRM_LINK = gql`
  fragment crmLink on CrmLink {
    crmId
    name
    type
    url
  }
`;
